import(/* webpackMode: "eager" */ "/home/ubuntu/projects/shopryze/os-storefront-blue/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/projects/shopryze/os-storefront-blue/src/components/home/DoctorsTestimonialsSectionDesktop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/projects/shopryze/os-storefront-blue/src/components/home/DoctorsTestimonialsSectionMobile.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/projects/shopryze/os-storefront-blue/src/components/home/FindYourAtomSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/projects/shopryze/os-storefront-blue/src/components/home/GlobalMapSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/projects/shopryze/os-storefront-blue/src/components/home/PromiseIconsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/projects/shopryze/os-storefront-blue/src/components/home/QualityBarSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/projects/shopryze/os-storefront-blue/src/components/home/TimeToSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/projects/shopryze/os-storefront-blue/src/components/home/TrustedFacesSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/projects/shopryze/os-storefront-blue/src/components/home/TrustStatsSection.tsx");
